import { createSlice } from '@reduxjs/toolkit';

const reducerName = 'jobTasksData';
const initialState = {
  sort: {
    id: 'created_at',
    label: 'Most recent',
    element: 'created_at',
    order: 'desc',
  },
  scorecardTasks: {
    data: [],
    meta: {},
    isLoading: true,
  },
  jobApprovalTasks: { data: [], meta: {}, isLoading: true },
  offerApprovalTasks: { data: [], meta: {}, isLoading: true },
  surveyTasks: { data: [], meta: {}, isLoading: true },
  requisitionApprovalTasks: { data: [], meta: {}, isLoading: true },
  unifiedApprovalTasks: { data: [], meta: {}, isLoading: true },
  page: { number: 0 },
};

const { reducer, actions: jobTasksActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    applyTasksSort: (state, { payload }) => {
      state.sort = payload;
    },

    setTasksLoading: (state, { payload }) => {
      state.jobApprovalTasks.isLoading = true;
      state.offerApprovalTasks.isLoading = true;
      state.scorecardTasks.isLoading = true;
      state.surveyTasks.isLoading = true;
      state.requisitionApprovalTasks.isLoading = true;
      state.unifiedApprovalTasks.isLoading = true;
    },

    applyScoreCardTasks: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state.scorecardTasks.data = data;
      state.scorecardTasks.meta = meta;
      state.scorecardTasks.isLoading = false;
    },

    applyJobApprovalTasks: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state.jobApprovalTasks.data = data;
      state.jobApprovalTasks.meta = meta;
      state.jobApprovalTasks.isLoading = false;
    },

    applyOfferApprovalTasks: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state.offerApprovalTasks.data = data;
      state.offerApprovalTasks.meta = meta;
      state.offerApprovalTasks.isLoading = false;
    },

    applySurveyTasks: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state.surveyTasks.data = data;
      state.surveyTasks.meta = meta;
      state.surveyTasks.isLoading = false;
    },
    applyRequisitionApprovalTasks: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state.requisitionApprovalTasks.data = data;
      state.requisitionApprovalTasks.meta = meta;
      state.requisitionApprovalTasks.isLoading = false;
    },

    applyUnifiedApprovalTasks: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state.unifiedApprovalTasks.data = data;
      state.unifiedApprovalTasks.meta = meta;
      state.unifiedApprovalTasks.isLoading = false;
    },

    applyPage: (state, { payload }) => {
      const { page } = payload;
      state.page.number = page;
    },
  },
});

export { jobTasksActions };
export default reducer;
